module.exports = __webpack_public_path__ + "img/Breaking_bad_Thumb.2ec2e266.jpg";